export default __webpack_public_path__ + "static/media/user-flows.906c1f82.png";